import { JsonObject } from 'ta-json';
import { Asset } from '@ess/jg-rule-executor';
import {
  GetAllRetailers_allRetailers_edges_node_retailerOptions_configuratorOptions_banner,
  GetAllRetailers_allRetailers_edges_node_retailerOptions_configuratorOptions_favicon,
} from '@src/app/generated/GetAllRetailers';
import { AssetInput } from '@src/app/generated/globalTypes';
import { GetAllModuleBlueprints_allBlueprints_model } from '@src/app/generated/GetAllModuleBlueprints';

/**
 * Extension of asset to convert from-and-to gql object
 */
@JsonObject()
export class PortalAsset extends Asset {
  static fromGql(
    gql:
      GetAllRetailers_allRetailers_edges_node_retailerOptions_configuratorOptions_favicon
      | GetAllRetailers_allRetailers_edges_node_retailerOptions_configuratorOptions_banner
      | GetAllModuleBlueprints_allBlueprints_model
  ): PortalAsset {
    return new PortalAsset(
      gql.id,
      gql.filename,
      gql.directory,
      gql.mimeType,
      gql.url
    );
  }

  toGqlInput(): AssetInput {
    return {
      id: this.id,
      filename: this.filename,
      directory: this.directory,
      mimeType: this.mimeType,
    };
  }

  static fromAsset(a: Asset): PortalAsset {
    return new PortalAsset(
      a.id,
      a.filename,
      a.directory,
      a.mimeType,
      a.url
    );
  }
}
